"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumTeam = exports.SourgumTeamLabels = exports.SourgumTeams = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.SourgumTeams = [
    'BILLING',
    'DISPATCH',
    'CUSTOMER_SERVICE',
    'VENDOR_RELATIONS',
    'VENDOR_RELATIONS_COMMERCIAL',
    'CONTRACTOR_SALES',
    'COMMERCIAL_SALES',
    'CONTRACTOR_ACCOUNT_MANAGERS',
    'COMMERCIAL_ACCOUNT_MANAGERS',
];
exports.SourgumTeamLabels = {
    BILLING: 'Billing',
    DISPATCH: 'Dispatch',
    CUSTOMER_SERVICE: 'Customer Service',
    VENDOR_RELATIONS: 'Vendor Relations',
    CONTRACTOR_SALES: 'Contractor Sales',
    COMMERCIAL_SALES: 'Commercial Sales',
    CONTRACTOR_ACCOUNT_MANAGERS: 'Contractor Account Managers',
    COMMERCIAL_ACCOUNT_MANAGERS: 'Commercial Account Managers',
    VENDOR_RELATIONS_COMMERCIAL: 'Vendor Relations Commercial',
};
exports.SourgumTeam = typebox_1.Type.Union(exports.SourgumTeams.map((value) => typebox_1.Type.Literal(value)));
//# sourceMappingURL=sourgum-teams.js.map